"use strict";
/*
 * Copyright (C) 2021 JET PROTOCOL HOLDINGS, LLC.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amount = exports.JET_MARKET_ADDRESS_DEVNET = exports.JET_MARKET_ADDRESS = exports.JET_ID = exports.DEX_ID_DEVNET = exports.DEX_ID = exports.PLACEHOLDER_ACCOUNT = void 0;
const web3_js_1 = require("@solana/web3.js");
const anchor = __importStar(require("@project-serum/anchor"));
__exportStar(require("./client"), exports);
__exportStar(require("./idl"), exports);
__exportStar(require("./market"), exports);
__exportStar(require("./obligation"), exports);
__exportStar(require("./reserve"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./user"), exports);
exports.PLACEHOLDER_ACCOUNT = web3_js_1.PublicKey.default;
// FIXME: this is probably different on devnet
exports.DEX_ID = new web3_js_1.PublicKey("9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin");
exports.DEX_ID_DEVNET = new web3_js_1.PublicKey("DESVgJVGajEgKGXhb6XmqDHGz3VjdgP7rEVESBgxmroY");
// FIXME: ???
exports.JET_ID = new web3_js_1.PublicKey("JPv1rCqrhagNNmJVM5J1he7msQ5ybtvE1nNuHpDHMNU");
exports.JET_MARKET_ADDRESS = new web3_js_1.PublicKey("9oiXzad28vLhT2TkFoVRRRcwYKrSF7E3XPUJpwcarCAo");
exports.JET_MARKET_ADDRESS_DEVNET = new web3_js_1.PublicKey("2mt2XQS6kKgkE2MPR9fFoWDv5ZYYNXkVGxgg9c9jMPRU");
/**
 * TODO:
 * @export
 * @class Amount
 */
class Amount {
    /**
     * Creates an instance of Amount.
     * @param {AmountUnits} units
     * @param {anchor.BN} value
     * @memberof Amount
     */
    constructor(units, value) {
        this.units = units;
        this.value = value;
    }
    /**
     * TODO:
     * @static
     * @param {(number)} amount
     * @returns {Amount}
     * @memberof Amount
     */
    static tokens(amount) {
        return new Amount({ tokens: {} }, new anchor.BN(amount));
    }
    /**
     * TODO:
     * @static
     * @param {(number | u64)} amount
     * @returns {Amount}
     * @memberof Amount
     */
    static depositNotes(amount) {
        return new Amount({ depositNotes: {} }, new anchor.BN(amount));
    }
    /**
     * TODO:
     * @static
     * @param {(number | u64)} amount
     * @returns {Amount}
     * @memberof Amount
     */
    static loanNotes(amount) {
        return new Amount({ loanNotes: {} }, new anchor.BN(amount));
    }
    /**
     * Converts the class instance into an object that can
     * be used as an argument for Solana instruction calls.
     * @returns {{ units: never; value: anchor.BN }}
     * @memberof Amount
     */
    toRpcArg() {
        return {
            units: this.units,
            value: this.value
        };
    }
}
exports.Amount = Amount;
//# sourceMappingURL=index.js.map